<template>
  <div class="messageInfoRow">
    <div style="flex-grow: 1" />
    <div v-if="message.IsEdited || message.isEdited" class="editedLabel">düzenlendi</div>
    <div v-if="message.isStarredMessage">
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16" height="15">
        <path fill="#92A58C" d="M8.3 10.2l-2.5 1.7c-.3.2-.8-.1-.7-.5L6 8.6c.1-.2 0-.4-.2-.5L3.5 6.3c-.4-.3-.2-.8.2-.8l3-.1c.2 0 .3-.1.4-.3l1-2.8c.1-.4.7-.4.8 0l1 2.8c.1.2.2.3.4.3l3 .1c.4 0 .6.5.3.8l-2.4 1.8c-.1.1-.2.3-.2.5l.9 2.9c.1.4-.3.7-.7.5l-2.5-1.7c-.1-.2-.3-.2-.4-.1z" />
      </svg>
    </div>
    <div>{{ getMessageDate() | moment('HH:mm') }}</div>

    <div v-if="$store.state.session.user.UserID === message.From && message.Status <= 3">
      <img class="statusIcon" :src="messageStatus" />
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  mixins: [messageMixin],

  computed: {
    messageStatus() {
      let message = {
        ...this.message
      }
      let status = message.Status
      // if (message.Status === 0) {
      //   status = 1
      // }
      if (message.isGroup) {
        let messageStatuses = this.$store.state.messagestatus.messageStatuses.filter((ms) => ms.MessageID === message.MessageID && ms.UserID !== this.$store.state.session.user.UserID)

        let unseenCount = 0
        let undeliveredCount = 0
        var msgStatus = Math.min(...messageStatuses.map((x) => x.Status))
        if (msgStatus !== undefined && msgStatus > 0) {
          status = msgStatus
        }

        // messageStatuses.forEach(ms => {
        //   if (ms.Status !== 2) {
        //     undeliveredCount++
        //   }
        //   if (ms.Status !== 3) {
        //     unseenCount++
        //   }
        // })

        // if (unseenCount === 0) {
        //   status = 3
        // } else if (undeliveredCount === 0) {
        //   status = 2
        // } else {
        //   status = 1
        // }
      }

      let url = '/images/status/status' + status + '.png'
      return url
    }
  },

  created() {}
}
</script>

<style lang="less" scoped>
.messageInfoRow {
  font-size: 11px;
  color: dimgray;
  padding-top: 5px;
  display: flex;
  margin-right: -15px;
}

.editedLabel {
  font-size: 10px;
  font-style: italic;
  color: #8696a0;
  margin-right: 5px;
}

.statusIcon {
  width: 10px;
  height: 10px;
  margin-left: 5px;
}
</style>
